import { render, staticRenderFns } from "./recyclingOrder.vue?vue&type=template&id=62d6ffda&scoped=true&"
import script from "./recyclingOrder.vue?vue&type=script&lang=js&"
export * from "./recyclingOrder.vue?vue&type=script&lang=js&"
import style0 from "./recyclingOrder.vue?vue&type=style&index=0&id=62d6ffda&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d6ffda",
  null
  
)

export default component.exports